import {createRoot} from 'react-dom/client'
import Root from './Root'
import './scrollIntoViewIfNeeded'
import registerClientErrorHandlers from './utils/registerClientErrorHandlers'
import retryChunkLoadErrorOnce from './utils/retryChunkLoadErrorOnce'

registerClientErrorHandlers()
retryChunkLoadErrorOnce()
const container = document.getElementById('root')!
createRoot(container).render(<Root />)
// Browsers refuse a service worker from a self-signed certificate & log an error on every page load,
// so in development the worker is only registered when the dev server runs over http
const canRegisterServiceWorker = __PRODUCTION__ || window.location.protocol === 'http:'
if (canRegisterServiceWorker && 'serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    navigator.serviceWorker.register('/sw.js', {scope: '/'}).catch(console.error)
  })
}

// window.addEventListener('beforeinstallprompt', (e) => {
//   // Stash the event so it can be triggered later.
//   console.log("ready to install")
//   // call e.prompt() somewhere
//   e.userChoice
//     .then((choiceResult) => {
//       if (choiceResult.outcome === 'accepted') {
//         console.log('User accepted the A2HS prompt');
//       } else {
//         console.log('User dismissed the A2HS prompt');
//       }
//       e = null;
//     });
// });
//
// window.addEventListener('appinstalled', (evt) => {
//   console.log('a2hs installed');
// });
